import { render, staticRenderFns } from "./card-gift.vue?vue&type=template&id=9f7a2c44&"
import script from "./card-gift.vue?vue&type=script&lang=js&"
export * from "./card-gift.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../vue-cli-build/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports